import { useTranslation } from 'react-i18next';
import styles from './Lucky.module.css';

/**
 * Renders a day's obstacle/caveat flags (Mercury retrograde, void-of-course Moon,
 * eclipse season, …) as a single ⚠️ line. Mirrors the bot's obstacle line so the
 * Mini App finally surfaces the caveats the backend has always returned.
 */
export function LuckyObstacles({ flags }: { flags: string[] }): JSX.Element | null {
  const { t } = useTranslation('flows');
  if (flags.length === 0) return null;
  const labels = flags.map((f) => t(`lucky.obs.${f}`)).join(', ');
  return (
    <p className={styles.obstacles} data-testid="lucky-obstacles">
      ⚠️ {labels}
    </p>
  );
}
